(function ($) {
  Drupal.behaviors.offer = {
    attach: function (context) {
      $categories = $('.offer__category', context);
      $categories.matchHeight();

      var $detailsLink = $('.offer-hero__link', context);
      var $dropdown = $('.offer-hero__dropdown', context);
      var $content = $('.offer-hero__dropdown-content > div', $dropdown);

      $detailsLink.click(function (event) {
        event.preventDefault();
        $dropdown.toggle();
        $dropdown.matchHeight();
      });
    }
  };
})(jQuery);
